import card from './card';

const baseStyle = props => ({
  ...card.baseStyle(props),
});

export default {
  baseStyle,
  sizes: card.sizes,
  variants: {
    ghost: {
      background: 'transparent',
      boxShadow: 'none',
    },
    shadow: {
      boxSizing: 'border-box',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'gray.100',
      boxShadow: '0 1px 10px rgba(0,0,0,0.1)',
    },
  },
  defaultProps: card.defaultProps,
};
